import { gerarCodigoInspecao, paraDataIso, uuidv7 } from '@qsms/shared'
import { banco } from './banco.js'
import { enfileirar } from './sincronizacao.js'

/// Criação de inspeção. Mora aqui porque dois caminhos chegam nela — o botão
/// "Nova ação" da tela inicial e a lista de checklists — e duplicar a regra do
/// código, do enfileiramento ou do carimbo de data significaria duas versões da
/// verdade sobre o que é uma inspeção recém-criada.
///
/// A inspeção nasce completa e com código definitivo, sem nunca falar com o
/// servidor: é a mesma regra do Power Apps (`{cod_obra}-{8 caracteres}`), porque
/// dois aparelhos offline não têm como combinar um número sequencial.
export async function criarInspecao(obraId: string, checklistId: string): Promise<string> {
  const obra = await banco.obras.get(obraId)
  const agora = new Date()
  const id = uuidv7(agora.getTime())

  await banco.inspecoes.add({
    id,
    codigo: gerarCodigoInspecao(obra?.codigo, id),
    checklistId,
    obraId,
    status: 'RASCUNHO',
    titulo: null,
    dataCriacao: paraDataIso(agora),
    assinaturaUsuario: null,
    criticidadeApia: null,
    registradoEm: agora.toISOString(),
    atualizadoEm: agora.toISOString(),
    respostas: [],
    fotos: [],
    versaoServidor: null,
    sincronizacao: 'PENDENTE',
    problema: null,
    remota: false,
  })

  // Entra na fila já na criação. Antes, uma inspeção aberta e abandonada pelo
  // "← Voltar" ficava marcada como pendente sem nenhum item de fila: a tela
  // inicial dizia que ela subiria sozinha e a barra de sincronização dizia que não
  // havia nada para enviar. Os dois contadores se contradiziam, e o trabalho não
  // saía do aparelho.
  await enfileirar(id)
  return id
}
